module.exports = __webpack_public_path__ + "static/media/twitter-footer.4fd0d23d.svg";